// config/tableConfigs/ticketManagement.js
// Mirrors the SchemeManagement config pattern for Ticket Management

export const TicketManagement = {
  title: "Ticket Management",
  subtitle: "Manage and track all support tickets",
  apiUrl: "https://pro.mokshiq.in/ticket_manager_action",

  // ── Columns shown in DataTable ──────────────────────────────────────────
  columns: [
    { key: "ticket_id",    label: "Ticket ID",    sortable: true,  width: "120px" },
    { key: "title",        label: "Subject",       sortable: true,  width: "220px" },
    { key: "ticket_type",  label: "Type",          sortable: true,  width: "120px" },
    { key: "priority",     label: "Priority",      sortable: true,  width: "100px" },
    { key: "status",       label: "Status",        sortable: true,  width: "120px" },
    { key: "assigned_to",  label: "Assigned To",   sortable: false, width: "140px" },
    { key: "amount",       label: "Amount (₹)",    sortable: true,  width: "110px" },
    { key: "created_at",   label: "Created",       sortable: true,  width: "130px" },
    { key: "actions",      label: "Actions",       sortable: false, width: "110px" },
  ],

  // ── Badge colour mappings ─────────────────────────────────────────────
  badgeMap: {
    status: {
      open:        { label: "Open",        color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
      in_progress: { label: "In Progress", color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
      pending:     { label: "Pending",     color: "#7c3aed", bg: "#f5f3ff", border: "#ddd6fe" },
      resolved:    { label: "Resolved",    color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
      closed:      { label: "Closed",      color: "#475569", bg: "#f1f5f9", border: "#cbd5e1" },
    },
    priority: {
      low:      { label: "Low",      color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
      medium:   { label: "Medium",   color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
      high:     { label: "High",     color: "#d97706", bg: "#fffbeb", border: "#fde68a" },
      critical: { label: "Critical", color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
    },
  },

  // ── Role-based permission matrix ──────────────────────────────────────
  //  Roles correspond to your Role model: main_admin / admin / white_label /
  //  super_distributor / distributor / retailer
  permissions: {
    main_admin:        { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    admin:             { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    white_label:       { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    super_distributor: { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: false },
    distributor:       { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: false },
    retailer:          { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: false },
    api_partner:       { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
    platform_user:     { canCreate: true,  canEdit: true,  canDelete: true,  canView: true,  canExport: true,  canAssign: true  },
  },

  // ── Filter / search fields ────────────────────────────────────────────
  filters: [
    { key: "status",      label: "Status",   type: "select",
      options: ["", "open", "in_progress", "pending", "resolved", "closed"] },
    { key: "priority",    label: "Priority", type: "select",
      options: ["", "low", "medium", "high", "critical"] },
    { key: "ticket_type", label: "Type",     type: "select",
      options: ["", "payment", "kyc", "fraud", "account", "bug", "support"] },
  ],

  // ── Ticket type options (used in form) ────────────────────────────────
  ticketTypeOptions: [
    { value: "payment",  label: "💳 Payment Issue"    },
    { value: "kyc",      label: "🪪 KYC / Compliance"  },
    { value: "fraud",    label: "🚨 Fraud Alert"       },
    { value: "account",  label: "👤 Account Issue"     },
    { value: "bug",      label: "🐛 Bug / Technical"   },
    { value: "support",  label: "🎧 General Support"   },
  ],

  statusOptions: [
    { value: "open",        label: "Open"        },
    { value: "in_progress", label: "In Progress" },
    { value: "pending",     label: "Pending"     },
    { value: "resolved",    label: "Resolved"    },
    { value: "closed",      label: "Closed"      },
  ],

  priorityOptions: [
    { value: "low",      label: "Low"      },
    { value: "medium",   label: "Medium"   },
    { value: "high",     label: "High"     },
    { value: "critical", label: "Critical" },
  ],
};